<template>
  <div class="home">

    <dashboard/>
  </div>
</template>

<script>
import dashboard from "@/components/IssueBond.vue";

export default {
  name: "IssueBond",
  components: {
    dashboard
  }
};
</script>
